import { render, staticRenderFns } from "./WebinarRoomRecords.vue?vue&type=template&id=62edd7ae"
import script from "./WebinarRoomRecords.vue?vue&type=script&lang=js"
export * from "./WebinarRoomRecords.vue?vue&type=script&lang=js"
import style0 from "./WebinarRoomRecords.vue?vue&type=style&index=0&id=62edd7ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports